module.exports = __webpack_public_path__ + "img/ayan-nag-valley.d33e9d6.jpg";